<template>
  <v-tabs
    v-model="vModel"
    :key="tabsKey"
    :height="$mqPick({ sm: '44', md: '48' })"
    color="text"
    align-tabs="center"
    v-bind="$attrs"
  >
    <v-tab
      v-for="tab in tabs"
      :key="tab.key"
      :value="tab.key"
      :disabled="tab.disabled"
      :class="{ 'd-none': tab.disabled }"
      @click="tabClickHandle(tab)"
    >
      {{ tab.label }}
    </v-tab>
  </v-tabs>
</template>
<script>
export default {
  name: 'AppTabs',
  props: {
    tabs: {
      type: Array,
      required: true
    },
    modelValue: {
      type: [String, null]
    },
    tabClick: {
      type: [Function, null]
    }
  },
  data() {
    return {
      tabOptions: '',
      tabsKey: 1
    };
  },
  watch: {
    tabs() {
      /*Fix tabs bottom slider position on update*/
      this.tabsKey += 1;
    }
  },
  computed: {
    vModel: {
      get() {
        return this.modelValue;
      },
      set(localState) {
        this.$emit('update:modelValue', localState);
      }
    }
  },
  methods: {
    tabClickHandle(val) {
      this.$emit('tab-click', val.key);
    }
  }
};
</script>
<style lang="scss">
.v-application {
  .v-tabs {
    .v-slide-group__next,
    .v-slide-group__prev {
      display: none !important;
    }
    /* v2 shipped slider-size="4"; Vuetify 3 dropped the prop and draws 2px */
    .v-tab__slider {
      height: 4px;
    }
  }
  .v-tab {
    text-transform: none;
    font-size: 1.125rem;
    letter-spacing: 0.0125em;
    line-height: 2rem;
    font-weight: 800;
    padding: 0 24px;
  }
  @media (max-width: 767px) {
    .v-tabs {
      padding: 0 4px;
      height: 44px !important;
      .v-tab__slider {
        height: 2px !important;
      }
    }
    .v-tab {
      font-size: 14px;
      font-weight: 600;
      padding: 6px 8px 0;
    }
  }
}

/*
 * Both Vuetify 2 and 3 centre tabs by putting `margin-inline-start: auto` on
 * the content's `:first-child` and `margin-inline-end: auto` on its
 * `:last-child`. A tab disabled by the parent is hidden with `d-none`, but it
 * is still the DOM `:last-child` — and an auto margin on a `display: none`
 * element resolves to nothing. With the last tab hidden (a hotel with no
 * bookable rooms) only the leading auto margin survived and the group was
 * shoved to the right edge. Centring the flex line instead is immune to which
 * children happen to be hidden.
 */
.v-tabs {
  .v-slide-group__content {
    justify-content: center;

    > :first-child {
      margin-inline-start: 0;
    }
    > :last-child {
      margin-inline-end: 0;
    }
  }
}

/*
 * Vuetify 3 stamps `v-theme--light` on each tab button rather than on the
 * `.v-tabs` wrapper, so a `.v-theme--light.v-tabs` prefix never matched and
 * unselected tabs fell back to plain black instead of v2's grey.
 */
.v-tabs {
  .v-tab--disabled,
  .v-tab:not(.v-tab--selected),
  .v-tab:not(.v-tab--selected) > .v-btn,
  .v-tab:not(.v-tab--selected) > .v-icon {
    color: rgb(var(--v-theme-light));
  }
  .v-tab.v-tab--selected {
    color: rgb(var(--v-theme-text));
  }
}
</style>
